import React from "react";

const NoEvidenceChains = ({
  text = "No evidence chains available",
  reason = null,
  entityId = null
}) => {
  let explanation = null;

  if (reason === "entity-not-found") {
    explanation = (
      <p className="evidence-explanation">
        The selected entity could not be found in the database or has no associated data.
        Try searching for a related compound or target.
      </p>
    );
  } else if (reason === "no-connections") {
    explanation = (
      <p className="evidence-explanation">
        No connections were found between the selected entities within the current search constraints.
        Try relaxing filters or expanding the search radius.
      </p>
    );
  } else if (reason === "data-mismatch") {
    explanation = (
      <p className="evidence-explanation">
        There is a data inconsistency between search results and the graph database.
        This entity may have been recently updated. Try refreshing your search or selecting a different entity.
      </p>
    );
  }

  return (
    <div className="no-evidence-chains-container">
      <h3 className="no-evidence-chains">{text}</h3>
      {explanation}
      {entityId && (
        <p className="entity-id-info">
          Entity: <code>{entityId}</code>
        </p>
      )}
    </div>
  );
};

export default NoEvidenceChains;
